// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart2_first__ZC61Y","second":"Chart2_second__2YTVR","third":"Chart2_third__2JJjN","four":"Chart2_four__t5x3E","five":"Chart2_five__1BX4V","six":"Chart2_six__EVlXe"};